import React from "react";
import { CopyIcon } from "lucide-react";
import { IconTooltip } from "../shared/ui/tooltip";

interface CopyButtonWithToastProps {
  copyContent: string;
  size?: number;
  [key: string]: unknown;
}

const CopyButtonWithToast = ({
  copyContent,
  size,
  ...props
}: CopyButtonWithToastProps) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(copyContent as string);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 2000); // Automatically hide tooltip after 2 seconds
  };

  return (
    <div className="relative inline-block" {...props}>
      <button
        className="w-[12px] cursor-pointer"
        aria-label="Copy"
        type="button"
        onClick={handleCopy}
      >
        <IconTooltip
          content={showTooltip && "Copied"}
          className="bg-gray-800 text-white"
          forceShow
        >
          <CopyIcon size={size} />
        </IconTooltip>
      </button>
    </div>
  );
};

export default CopyButtonWithToast;
